import React from 'react';
import { Reveal } from './Reveal';
const tags = ['5 min', '15 min', '30 min', 'Guiones', 'Planificador', 'Kit Eval. Vínculo'];
const volumes = [{
  emoji: '📘',
  title: 'Tomo 1 — Base Presente',
  subtitle: 'Fundamentos · Sin culpa',
  description: 'Fundamentos: cómo generar conexión real en poco tiempo, sin culpa ni perfeccionismo.',
  quantity: '8 ejercicios de autodiagnóstico + guía de mentalidad'
}, {
  emoji: '📗',
  title: 'Tomo 2 — Rutinas de 5 minutos',
  subtitle: 'Días imposibles',
  description: 'Micro-momentos de conexión para los días imposibles: antes de salir, en el auto, antes de dormir.',
  quantity: '10 fichas de micro-momentos listas para imprimir'
}, {
  emoji: '📙',
  title: 'Tomo 3 — Rutinas de 15 minutos',
  subtitle: 'Después del trabajo',
  description: 'Actividades cortas pero profundas para después del trabajo, sin necesitar preparación.',
  quantity: '30 actividades sin preparación previa'
}, {
  emoji: '📕',
  title: 'Tomo 4 — Rutinas de 30 minutos',
  subtitle: 'Tiempo disponible',
  description: 'Para cuando hay un poco más de tiempo: juegos, conversaciones guiadas, proyectos simples juntos.',
  quantity: '40 juegos + 40 conversaciones guiadas'
}, {
  emoji: '📓',
  title: 'Tomo 5 — Fines de semana con sistema',
  subtitle: 'Sistema de sábado/domingo',
  description: 'Planificación de actividades de conexión para sábados y domingos, sin que se pierdan en trámites o pantallas.',
  quantity: 'Planificador de 20 fines de semana'
}, {
  emoji: '📔',
  title: 'Tomo 6 — Kit de Momentos Difíciles',
  subtitle: 'Culpa bajo control',
  description: 'Qué hacer y qué decir en las situaciones que más culpa generan: viajes de trabajo, cumpleaños perdidos, llegadas tarde.',
  quantity: '60 guiones para situaciones específicas'
}];
const includes = ['Actividades listas, sin preparación previa', 'Guiones de frases para cada situación', 'Versión imprimible y versión digital', 'Adaptado a distintas edades (3-6, 7-9, 10-12)', 'Explicación breve del “por qué funciona”'];
export function ProductSection() {
  return <section id="producto" aria-label="El producto" className="w-full bg-cream-100 py-16 sm:py-24" data-id="element-156" data-mp="21chm7w2uq0o">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-157" data-mp="3t7vz25wf5e7y">
        <Reveal data-id="element-158" data-mp="b0zkyz8da5wd">
          <div className="text-center" data-id="element-159" data-mp="b1hlw95z58am">
            <h2 className="font-display text-3xl font-semibold tracking-tight text-bark-900 sm:text-4xl" data-id="element-160" data-mp="6ycoum4nxytd">
              🏆 KIT PADRES PRESENTES™
            </h2>
            <p className="mt-3 font-display text-lg font-medium text-terracotta-600 sm:text-xl" data-id="element-161" data-mp="kw9l1hf7g37i">
              6 Tomos + 3 Bonos + 2 Recursos Extra
            </p>
            <p className="mt-2 text-sm font-medium text-bark-400 sm:text-base" data-id="element-162" data-mp="uo6y6tprx58v">
              — Todo resuelto —
            </p>

            
          </div>
        </Reveal>

        <Reveal delay={0.05} data-id="element-163" data-mp="13oc4f0j8dxlg">
          <h3 className="mt-14 text-center text-xs font-bold uppercase tracking-[0.2em] text-bark-400" data-id="element-164" data-mp="13pn70x0xwzaz">
            6 Tomos completos
          </h3>
        </Reveal>

        <div className="mt-7 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-165" data-mp="1ibk8zii1b4og">
          {volumes.map((vol, i) => <Reveal key={vol.title} delay={i * 0.06} data-id="element-166" data-mp="1na5armcxpwf0" data-mpi={i}>
              <article className="flex h-full flex-col rounded-3xl border border-bark-800/[0.08] bg-cream-50 p-6 shadow-sm transition-shadow duration-200 hover:shadow-warm" data-id="element-167" data-mp="1n9vlk0zprtad">
                <span aria-hidden="true" className="text-3xl" data-id="element-168" data-mp="1db6cmxpspj69">
                  {vol.emoji}
                </span>
                <h4 className="mt-4 font-display text-lg font-semibold leading-snug text-bark-900" data-id="element-169" data-mp="zk1a9nv1mcs8">
                  {vol.title}
                </h4>
                <p className="mt-1 text-sm italic text-bark-400" data-id="element-170" data-mp="pmwuq6vpdfke">{vol.subtitle}</p>
                <p className="mt-2.5 text-sm leading-relaxed text-bark-600" data-id="element-171" data-mp="pksi90jqn88i">{vol.description}</p>
                <p className="mt-4 flex items-start gap-1.5 text-sm font-semibold leading-snug text-terracotta-600" data-id="element-172" data-mp="ujdi2yv2vpwf">
                  <span aria-hidden="true" data-id="element-173" data-mp="lks4li4gr12i">→</span>
                  <span data-id="element-174" data-mp="lkidtsblgpvr">{vol.quantity}</span>
                </p>
              </article>
            </Reveal>)}
        </div>

        <Reveal delay={0.05} data-id="element-175" data-mp="dmgbz7fm939f">
          <div className="mt-10 rounded-3xl bg-sage-100 p-7 sm:p-9" data-id="element-176" data-mp="8liukx2fkd8z">
            <h3 className="font-display text-xl font-semibold text-bark-900 sm:text-2xl" data-id="element-177" data-mp="8nc3kj0in9k5">
              Cada tomo incluye:
            </h3>
            <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-178" data-mp="3vz4sk9lvcn6v">
              {includes.map(item => <li key={item} className="flex items-start gap-3 text-[0.95rem] leading-relaxed text-bark-800" data-id="element-179" data-mp="3qyyxskkaykkk">
                  <span aria-hidden="true" className="mt-0.5 shrink-0" data-id="element-180" data-mp="3lzm7fpu82vd8">
                    ✅
                  </span>
                  <span data-id="element-181" data-mp="3h24209feyy9z">{item}</span>
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>;
}